export type AcademicProjectKind =
  | 'tcc'
  | 'internship'
  | 'assessmentWork'
  | 'evaluativeActivity';

export function academicProjectLabel(
  kind: AcademicProjectKind,
  purposeText?: string,
  title?: string,
): string {
  switch (kind) {
    case 'tcc':
      return 'TCC';
    case 'internship':
      return 'Estágio Supervisionado';
    case 'assessmentWork':
      return 'Trabalho Avaliativo';
    case 'evaluativeActivity':
      return purposeText || title || 'Atividade Avaliativa';
    default:
      return 'Projeto Acadêmico';
  }
}

export function isAcademicProjectKind(
  value: string | undefined,
): value is AcademicProjectKind {
  return (
    value === 'tcc' ||
    value === 'internship' ||
    value === 'assessmentWork' ||
    value === 'evaluativeActivity'
  );
}
